import { render, staticRenderFns } from "./BookmarkProductModal.vue?vue&type=template&id=de09a33e&"
import script from "./BookmarkProductModal.vue?vue&type=script&lang=js&"
export * from "./BookmarkProductModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductFormatSelector: require('/vercel/path0/components/product/ProductFormatSelector.vue').default,ShoppingListsSelector: require('/vercel/path0/components/profile/shopping-list/ShoppingListsSelector.vue').default,Modal: require('/vercel/path0/components/general/Modal.vue').default})
